import { render } from "./TIME.vue?vue&type=template&id=4fe47c7c&scoped=true"
import script from "./TIME.vue?vue&type=script&lang=js"
export * from "./TIME.vue?vue&type=script&lang=js"

import "./TIME.vue?vue&type=style&index=0&id=4fe47c7c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fe47c7c"]])

export default __exports__